import { useMutation, useQueryClient } from '@tanstack/react-query'

import { postRequest } from 'src/lib/api-client'
import { queries } from 'src/lib/query-keys'

import type { Business, BusinessCreate } from '../../shared/schemas/business'

const createBusiness = (businessCreateData: BusinessCreate) => {
  return postRequest<Business>('/business/', businessCreateData)
}

export const useCreateBusiness = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (businessCreateData: BusinessCreate) => createBusiness(businessCreateData),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queries.business.list._def })
      queryClient.invalidateQueries({ queryKey: queries.business.pending._def })
    },
  })
}
